import { render, staticRenderFns } from "./UserListDemographic.vue?vue&type=template&id=46c42c42&scoped=true&xmlns%3Ab-row=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./UserListDemographic.vue?vue&type=script&lang=js&"
export * from "./UserListDemographic.vue?vue&type=script&lang=js&"
import style0 from "./UserListDemographic.vue?vue&type=style&index=0&id=46c42c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c42c42",
  null
  
)

export default component.exports